import { BaseSyntheticEvent, useState } from 'react'

import { CheckboxSwitch, CheckboxSwitchProps } from '@/lib/core/components/CheckboxSwitch'

import { useUpdateSmartShareMapAccess } from '@/lib/features/SmartShares/api'
import { ShareId } from '@/lib/features/SmartShares/interfaces'

export type SwitchStatusProps = Omit<CheckboxSwitchProps, 'name'> & {
  shareId: ShareId
  defaultValue?: boolean
}

export const SwitchStatus = ({ shareId, defaultValue = false, ...props }: SwitchStatusProps) => {
  const [isChecked, setIsChecked] = useState(defaultValue)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { trigger: updateSmartShareMapAccess } = useUpdateSmartShareMapAccess()

  const handleUpdateStatus = async (isActive: boolean) => {
    setIsSubmitting(isActive)
    setIsChecked(isActive)

    try {
      await updateSmartShareMapAccess({
        data: { isActive },
        params: { id: shareId },
      })
      setIsChecked(isActive)
    } catch {
      setIsChecked(!isActive)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <CheckboxSwitch
      name={`status-${shareId}`}
      checked={isChecked}
      disabled={isSubmitting}
      onChange={({ target }: BaseSyntheticEvent) => handleUpdateStatus(target.checked)}
      {...props}
    />
  )
}
